module.exports = __webpack_public_path__ + "static/Flavor-German-Amarillo-T45-VA18000302-4963d3c5cb0d82aa43f7a5998f889f7e.pdf";